import { render, staticRenderFns } from "./NodeScreen.vue?vue&type=template&id=c56aaabc&lang=pug&"
import script from "./NodeScreen.vue?vue&type=script&lang=js&"
export * from "./NodeScreen.vue?vue&type=script&lang=js&"
import style0 from "./NodeScreen.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c56aaabc')) {
      api.createRecord('c56aaabc', component.options)
    } else {
      api.reload('c56aaabc', component.options)
    }
    module.hot.accept("./NodeScreen.vue?vue&type=template&id=c56aaabc&lang=pug&", function () {
      api.rerender('c56aaabc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/docs/NodeScreen.vue"
export default component.exports